var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrassLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 132,
    viewBox: "0 0 237 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.182 131.988C129.182 131.988 125.808 91.1103 119 54.4544L126.647 52C126.647 52 134.017 100.633 136 132L129.182 131.988Z",
    fill: "url(#paint0_linear_159_1965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 132C110 132 108.067 103.285 103.488 88.0753L99.1765 87.8792C100.651 95.1145 101.606 102.497 102.031 109.94H99.1765C99.1765 109.94 96.0544 81.2979 92.0699 63H81.5339V71.4442L79.2542 63H73C73 63 73.8524 106.287 73 131.975L110 132Z",
    fill: "url(#paint1_linear_159_1965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1571 132C89.1571 132 88.2976 89.7612 84 58H91.9955C91.9955 58 100.311 99.5338 99.991 132H89.1571Z",
    fill: "url(#paint2_linear_159_1965)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 126.82C140 126.82 145.156 95.9719 156.931 52.7168L161.636 54.8075C161.636 54.8075 152.709 86.1064 150.422 104.736C150.422 104.736 158.015 78.5196 164.976 60.9171L177.293 68.6667C177.293 68.6667 171.726 96.9234 168.075 119.308L169.831 119.396L181.275 61.3303L184.285 61.7809C184.285 61.7809 179.43 91.0016 176.441 125.318L184.465 125.994L189.48 100.116L194.245 100.329L191.125 127.221L194.476 127.371C194.476 127.371 201.848 71.3333 208.227 50L219 50.4757C219 50.4757 213.684 95.9718 211.206 130L140 126.82Z",
    fill: "url(#paint3_linear_159_1965)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213 129.864C215.463 103.81 220.824 78.2875 228.937 54L233 54.1734C233 54.1734 221.41 84.3554 216.332 130L213 129.864Z",
    fill: "url(#paint4_linear_159_1965)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 126.641C139 126.641 143.319 90.9428 147.905 63L156 63.3711C151.633 84.2414 148.497 105.512 146.618 127L139 126.641Z",
    fill: "url(#paint5_linear_159_1965)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222 130.699C222 130.699 225.103 105.336 232.345 86L237 86.2005C232.572 100.602 229.822 115.68 228.828 131L222 130.699Z",
    fill: "url(#paint6_linear_159_1965)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 123.872C38 123.872 43.1557 74.1296 54.9314 4.38084L59.6357 7.75216C59.6357 7.75216 50.7086 58.2216 48.4216 88.2611C48.4216 88.2611 56.0147 45.9878 62.9759 17.6038L75.2933 30.1001C75.2933 30.1001 69.7264 75.6639 66.0753 111.76L67.8306 111.901L79.2754 18.27L82.2845 18.9968C82.2845 18.9968 77.4298 66.1151 74.4407 121.45L82.4651 122.54L87.4803 80.8118L92.2448 81.1549L89.1253 124.518L92.4755 124.761C92.4755 124.761 99.8479 34.4 106.227 0L117 0.767146C117 0.767146 111.684 74.1296 109.206 129L38 123.872Z",
    fill: "url(#paint7_linear_159_1965)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 129.778C113.463 87.2692 118.824 45.627 126.937 6L131 6.28292C131 6.28292 119.41 55.5272 114.332 130L111 129.778Z",
    fill: "url(#paint8_linear_159_1965)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 120.879C0 120.879 0.225491 83.8687 1.11765 56L3 56.1413C3 56.1413 1.64706 86.9965 1.87255 121L0 120.879Z",
    fill: "url(#paint9_linear_159_1965)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 122.536C16 122.536 19.2941 88.4704 26.6274 61L33 61.4639C33 61.4639 26.2059 85.445 22.3726 123L16 122.536Z",
    fill: "url(#paint10_linear_159_1965)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 130.512C120 130.512 123.103 89.3671 130.345 58L135 58.3252C130.572 81.687 127.822 106.147 126.828 131L120 130.512Z",
    fill: "url(#paint11_linear_159_1965)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.428 114.626C138.428 114.626 140.018 98.9929 139.428 87.3732L143.138 87.2207C143.138 87.2207 143.998 103.13 143.138 114.626H138.428Z",
    fill: "url(#paint12_linear_159_1965)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 132C70.8115 118.693 71.0913 105.343 70.8382 92H76.014C76.014 92 78.6749 115.41 77.8367 132H70Z",
    fill: "url(#paint13_linear_159_1965)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 123.417C37 123.417 41.3191 65.407 45.9052 20L54 20.603C49.6335 54.5172 46.4971 89.0826 44.6181 124L37 123.417Z",
    fill: "url(#paint14_linear_159_1965)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 125.153C53 125.153 60.3923 61.5902 71.0248 22L78 25.5312C78 25.5312 69.1331 75.8565 64.6317 126L53 125.153Z",
    fill: "url(#paint15_linear_159_1965)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_1965",
    x1: 127.495,
    y1: 131.988,
    x2: 127.495,
    y2: 51.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_1965",
    x1: 91.505,
    y1: 132,
    x2: 91.505,
    y2: 63.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_1965",
    x1: 92.0355,
    y1: 132,
    x2: 92.0355,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_159_1965",
    x1: 178.341,
    y1: 128.488,
    x2: 181.884,
    y2: 48.7955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_159_1965",
    x1: 221.874,
    y1: 130.21,
    x2: 225.193,
    y2: 53.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_159_1965",
    x1: 146.613,
    y1: 126.955,
    x2: 149.566,
    y2: 63.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_159_1965",
    x1: 228.83,
    y1: 130.957,
    x2: 230.773,
    y2: 85.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_159_1965",
    x1: 76.3405,
    y1: 126.562,
    x2: 85.524,
    y2: -1.53797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_159_1965",
    x1: 119.874,
    y1: 130.343,
    x2: 128.683,
    y2: 6.08006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_159_1965",
    x1: 0.835335,
    y1: 120.873,
    x2: 5.5712,
    y2: 56.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_159_1965",
    x1: 23.9876,
    y1: 122.999,
    x2: 28.5287,
    y2: 61.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_159_1965",
    x1: 126.83,
    y1: 130.93,
    x2: 131.929,
    y2: 58.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_159_1965",
    x1: 140.958,
    y1: 114.626,
    x2: 140.958,
    y2: 87.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_159_1965",
    x1: 73.9963,
    y1: 132,
    x2: 73.9963,
    y2: 91.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5B600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_159_1965",
    x1: 44.6127,
    y1: 123.926,
    x2: 52.3835,
    y2: 20.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_159_1965",
    x1: 64.6236,
    y1: 125.95,
    x2: 72.3215,
    y2: 22.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassLeft);
export default __webpack_public_path__ + "static/media/grassLeft.60f4a5a360ca00915badf6a8b216dc53.svg";
export { ForwardRef as ReactComponent };